/* eslint-disable */

export const stopAllBots = {
    STOP_ALL_REQUEST: 'STOP_ALL_REQUEST',
    STOP_ALL_SUCCESS: 'STOP_ALL_SUCCESS',
    STOP_ALL_FAILURE: 'STOP_ALL_FAILURE',
};
